var _ = require('underscore');
module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<li class="CDB-Widget-listItem CDB-Widget-listItem--fake"></li>\n<li class="CDB-Widget-listItem CDB-Widget-listItem--fake"></li>\n<li class="CDB-Widget-listItem CDB-Widget-listItem--fake"></li>\n<li class="CDB-Widget-listItem CDB-Widget-listItem--fake"></li>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./lib/assets/javascripts/deep-insights/widgets/category/list/items-placeholder-template.tpl
// module id = 341
// module chunks = 0 2